const ExportEnum = {
  NO_EXPORT_CLASS: 'no-export'
}

export default ExportEnum
